
/* eslint-disable */
import { State, Action } from 'vuex-class';

import { Component, Vue } from 'vue-property-decorator';

import { JigActivityChartData, JigSummaryStats, ReportRequest } from '@/store/modules/app/types';

import GenericError from '@/components/snackbars/GenericError.vue';
import { Report } from '@/store/modules/reports';

import StatLineChart from '@/components/statistics/StatLineChart.vue';
import { ColorSet } from '@/components/statistics/Contants';

const namespace: string = 'app';
const Top5 = 5;
const LookBackDays = 30;
const ComparePreviousPeriod = true;

const defaultActivityTrendChart: JigActivityChartData = {
  data: {
    labels: [],
    datasets: [
      {
        label: '',
        backgroundColor: '#f87979',
        data: [],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      point: {
        radius: 0,
      },
    },
    title: {
      display: true,
      text: 'Most Popular Jigs in 30 days',
    },
    legend: {
      display: true,
    },
    tooltips: {
      enabled: true,
    },
  },
};

  @Component({
    components: { StatLineChart, 'generic-error': GenericError },
  })

export default class CommandCentre extends Vue {
    @State('jigDailyActivityData', { namespace })
    public jigDailyActivityData?: JigSummaryStats[];

    @Action('executeStatisticReport', { namespace })
    public executeStatisticReport: any;

    private isFetchingJigData: boolean = false;

    private jigActivityTrendChart: JigActivityChartData = defaultActivityTrendChart;

    constructor() {
      super();
    }

    private get getJigActivityTrendChart(): JigActivityChartData {
      this.updateJigActivityTrendChart(this.jigDailyActivityData);
      return this.jigActivityTrendChart;
    }

    // support manual fetch rather than automatic on page opening fetching
    private async fetchJigActivityDataClick() {
      let today = new Date()
      let startDate = new Date()
      startDate.setDate(today.getDate() - 31)
      let endDate = new Date()
      endDate.setDate(today.getDate() - 1)

      const req: ReportRequest = {
        Name: Report.MostPopularJig,
        JigHashId: "",
        Limit: Top5,
        LookBackDays,
        StartDate: startDate.toISOString(),
        EndDate: endDate.toISOString(),
        ComparePreviousPeriod,
      };

      this.isFetchingJigData = true;
      await this.executeStatisticReport(req);
      this.isFetchingJigData = false;
    }

    private updateJigActivityTrendChart(jigSummaryComparisonStats?: JigSummaryStats[]) {
      if (jigSummaryComparisonStats == null) {
        return;
      }

      this.jigActivityTrendChart.data.datasets.length = 0;
      this.jigActivityTrendChart.data.labels.length = 0;

      let maxTotal = 0;
      const labels: string[] = [];

      // for each Jig capture a series of date (day) view totals.
      const jigActivitySeriesData: Map<number, number[]> = new Map<number, number[]>();

      // get a unique list of jig names.
      const jigNames: Map<number, string> = new Map<number, string>();

      jigSummaryComparisonStats.forEach((item: {
        id: number;
        statisticDate: string;
        application: string;
        jigId: number;
        jigName: string;
        activity: string;
        total: number;
        durationSeconds: number;
        duration: string;
      }) => {
        maxTotal = Math.max(maxTotal, item.total);
        const sd = new Date(item.statisticDate);
        if (jigActivitySeriesData.has(item.jigId)) {
          const s = jigActivitySeriesData.get(item.jigId);
          if (s) {
            // add another activity counter onto this Jig series.
            s.push(item.total);
          }
        } else {
          jigActivitySeriesData.set(item.jigId, [item.total]);
        }

        // keep a list of unique jig names
        if (!jigNames.has(item.jigId)) {
          jigNames.set(item.jigId, item.jigName);
        }

        // create month + date labels
        labels.push(sd.toLocaleString('en-US', { month: 'short' }) + '/' + sd.getDate().toString());
      });

      this.jigActivityTrendChart.data.labels = labels;

      // for each jig activity...
      let i = 0;
      jigActivitySeriesData.forEach((statisticData: number[], jigId: number) => {
        const jigName = jigNames.get(jigId) || 'Jig name not set';
        this.jigActivityTrendChart.data.datasets.push(
          {
            label: jigName,
            backgroundColor: ColorSet[i % ColorSet.length],
            data: statisticData,
          },
        );
        i++;
      });
    }
}
